import React from 'react';

const HomePage = () => {
    return (
        <div>
            <div className="nefarious">
                <div className='fiery'>
                    The Nefarious Machine
                </div>
            </div>
        </div>
    );
}

export default HomePage;